import { getToken } from '../helpers/Token';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import watcherUrls from "../configs/watcher/watcherUrls";

interface ApiInterface extends AxiosInstance {
  oneSky?: any;
}

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';

  if (!watcherUrls.isPublicUrl(config.baseURL, config.url)) {
    config.headers['Authorization'] = `Bearer ${getToken()}`;
  }

  return config;
}

const watcherApi: ApiInterface = axios.create({ baseURL: watcherUrls.baseURL });
watcherApi.interceptors.request.use(onRequest);

watcherApi.oneSky = {
  url: watcherUrls.remoteUrl.bind(watcherUrls),
  uploadHeaders: {
    'Authorization': `Bearer ${getToken()}`
  }
}

export default watcherApi;
